var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/*!
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
import { classMap, Component, CustomElement, Event, html, Prop, State, Watch } from '@sick-davinci/ce-decorators';
import { style } from './DrawerNavigation.style';
import { IconRef } from '@sick-davinci/basic-elements/lib/icon/IconRef';
import { icon_chevron_double_right as expandIcon } from './icons/chevron-double-right';
import { icon_chevron_double_right as closeIcon } from './icons/chevron-double-left';
/**
 * A `davinci-core-drawer-navigation` generates a collapsible navigation-sidepane.
 * Concerning height-adoption it works best inside an exclusive block-container with dedicated height (absolute or %).
 *
 * @example
 * ```html
 *  <davinci-core-drawer-navigation expanded>
 *    <davinci-core-drawer-navigation-item label="Home" route="/"></davinci-core-drawer-navigation-item>
 *    <davinci-core-drawer-navigation-item label="Search" route="/search"></davinci-core-drawer-navigation-item>
 *    <davinci-core-drawer-navigation-item label="Account" route="/user/profile"></davinci-core-drawer-navigation-item>
 *  </davinci-core-drawer-navigation>
 * ```
 */
export let DrawerNavigation = (_dec = Component({
  style: [style],
  tag: 'davinci-core-drawer-navigation',
  dependencies: [IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Event('expanded'), _dec5 = Reflect.metadata("design:type", Object), _dec6 = State(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = State(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = State(), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Watch('expanded'), _dec13 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class DrawerNavigation extends CustomElement {
  constructor(...args) {
    super(...args);
    /**
     * Determines if the drawer is displayed in its expanded or narrow (flyout) variant.
     */
    _initializerDefineProperty(this, "expanded", _descriptor, this);
    /**
     * Emits the new expanded state, if the expand-toggle is clicked
     */
    _initializerDefineProperty(this, "expandedEvent", _descriptor2, this);
    _initializerDefineProperty(this, "dynamicScrollbarTimeout", _descriptor3, this);
    _initializerDefineProperty(this, "showScrollbar", _descriptor4, this);
    _initializerDefineProperty(this, "childrenList", _descriptor5, this);
    _defineProperty(this, "_onToggleClicked", () => {
      this.expanded = !this.expanded;
      this.expandedEvent.emit(this.expanded);
      this._fixStickyHoverStyleOnSafari();
    });
    _defineProperty(this, "_scrollHandler", (_e, setDynamic = false) => {
      this._positionScrollbar();
      if (!this.expanded) {
        this._closeChildrenFlyout();
      }
      if (setDynamic) {
        this._updateDynamicScrollbar();
      }
    });
  }
  onExpansionChange() {
    if (!this.expanded) {
      this.classList.remove('expanded');
    } else {
      this.classList.add('expanded');
    }
    this._updateChildrenFlyoutMode();
    this._configNestedChildren();
  }
  componentFirstRender() {
    this.onExpansionChange();
    this._initScrollbarObservers();
  }
  componentWillRender() {
    if (!this._firstRender) {
      this._updateScrollbar();
    }
  }
  componentDidRender() {
    if (this._firstRender) {
      this.shadowRoot.querySelector('.children').addEventListener('scroll', () => this._scrollHandler(undefined, true));
      document.body.addEventListener('scroll', this._scrollHandler);
    }
  }
  componentDisconnected() {
    var _this$shadowRoot;
    if (this.scrollbarObserver) {
      this.scrollbarObserver.disconnect();
    }
    (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector('.children').removeEventListener('scroll', this._scrollHandler);
    document.body.removeEventListener('scroll', this._scrollHandler);
  }
  render() {
    return html`
      <div class="${classMap({
      children: true,
      scrollable: this.showScrollbar
    })}">
        <div class="content">
          <slot @slotchange="${this._onSlotChanged}"></slot>
        </div>
      </div>
      <div class="${classMap({
      'scrollbar-container': true,
      hidden: !this.showScrollbar
    })}">
        <div class="${classMap({
      scrollbar: true,
      visible: this.showScrollbar,
      dynamic: !!this.dynamicScrollbarTimeout
    })}"></div>
      </div>
      <div class="toggle-container">
        <div class="icon-box" @click="${() => this._onToggleClicked()}">
          <davinci-icon-ref class="icon toggle" src="${this.expanded ? closeIcon : expandIcon}"></davinci-icon-ref>
        </div>
      </div>
    `;
  }
  _closeChildrenFlyout(eventTarget) {
    this.childrenList.forEach(item => {
      if (item !== eventTarget || !eventTarget) {
        item.flyoutExpanded = false;
      }
    });
  }
  _initScrollbarObservers() {
    this.scrollbarObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        // avoid "ResizeObserver loop limit exceeded"-error
        this._updateScrollbar();
      });
    });
    this.scrollbarObserver.observe(this.shadowRoot.querySelector('.children'));
    this.scrollbarObserver.observe(this.shadowRoot.querySelector('.content'));
  }
  _updateScrollbar() {
    const childrenHeight = this.shadowRoot.querySelector('.children').getBoundingClientRect().height;
    const contentHeight = this.shadowRoot.querySelector('.content').getBoundingClientRect().height;
    this.showScrollbar = childrenHeight < contentHeight;
    this.scrollbarPercent = 100 / (contentHeight / childrenHeight);
    const scrollbarHeight = childrenHeight / (contentHeight / childrenHeight);
    this.shadowRoot.querySelector('.scrollbar-container').style.height = childrenHeight + 'px';
    this.shadowRoot.querySelector('.scrollbar').style.height = scrollbarHeight - 5 + 'px';
  }
  _positionScrollbar() {
    const childrenTop = this.shadowRoot.querySelector('.children').getBoundingClientRect().top;
    const contentTop = this.shadowRoot.querySelector('.content').getBoundingClientRect().top;
    const offsetTop = (childrenTop - contentTop) / 100 * this.scrollbarPercent;
    this.shadowRoot.querySelector('.scrollbar').style.transform = 'translateY(' + offsetTop + 'px)';
  }
  _onSlotChanged() {
    this.childrenList = Array.from(this.children);
    this.onExpansionChange();
    this._updateChildrenFlyoutMode();
    this._updateChildrenNestLevel();
  }
  _updateChildrenFlyoutMode() {
    this.childrenList.forEach(item => {
      item.flyoutMode = !this.expanded;
    });
  }
  _updateChildrenNestLevel() {
    this.childrenList.forEach(item => {
      item.nestLevel = 0;
    });
  }
  _configNestedChildren() {
    Array.from(this.querySelectorAll('davinci-core-drawer-navigation-item')).forEach(item => {
      item.drawerExpanded = this.expanded;
    });
  }
  _fixStickyHoverStyleOnSafari() {
    const iconBox = this.shadowRoot.querySelector('.icon-box');
    const container = iconBox.parentElement;
    container.removeChild(iconBox);
    container.appendChild(iconBox);
  }
  _updateDynamicScrollbar() {
    this._clearScrollbarTimeout();
    this._setScrollbarTimeout();
  }
  _clearScrollbarTimeout() {
    if (this.dynamicScrollbarTimeout) {
      window.clearTimeout(this.dynamicScrollbarTimeout);
      this.dynamicScrollbarTimeout = undefined;
    }
  }
  _setScrollbarTimeout() {
    this.dynamicScrollbarTimeout = window.setTimeout(() => {
      this.dynamicScrollbarTimeout = undefined;
    }, 750);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "expanded", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "expandedEvent", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "dynamicScrollbarTimeout", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showScrollbar", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "childrenList", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onExpansionChange", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "onExpansionChange"), _class2.prototype)), _class2)) || _class);
